module.exports = __webpack_public_path__ + "img/health-care.e4b4d6ff.jpg";